module.exports = __webpack_public_path__ + "img/Bag_w.4979df03.svg";